export default [

     {
          path: '/prevention-program',
          name: 'PreventionProgram',
          component: () => import("@/views/Page/PreventionProgram/PreventionProgram.vue"),
          meta: {
               title: 'Prevention Program',
          },
     }
];